import queryString from 'query-string';
import axios, { baseUrl } from './axios';

export default {
  getPreferredSiteList: async (options = {}) => {
    const params = queryString.stringify(options.filter);
    const result = await axios.get(
      `${baseUrl}/customer/pob/preferred_site${params ? `?${params}` : ''}`,
    );
    return result.data;
  },
};
